import React from "react";
import HeroSection from "../../components/HeroSection";
import PPCMarketing from "./PPCMarketing";
import Services1 from "./Services1";
import FAQ from "../../components/FAQ";
import Footer from "../Footer/Footer";
// import FormHeroSection from "../../components/FormHeroSection";

const PayPerClickMarkecting = () => {
  return (
    <>
      <HeroSection
        background=" linear-gradient(270deg,  #462443 ,#773455)"
        heading="Targeted Ad Campaignsg"
        img="/Images/caseStudy.png"
        subheading="pay per click marketing"
        deatailhedaing="Gain High-Level Brand Exposure and Attract More Leads PPC marketing services can be provided by digital marketing agencies, freelance digital marketers, or even directly by platforms like Google Ads or Facebook Ads."
      />
      <PPCMarketing />
      {/* <FormHeroSection/> */}

      <Services1 />
     
      <FAQ
        title="What is PPC advertising?"
        title1="How does PPC advertising work?"
        title2="What are the benefits of PPC advertising?"
        title3="How do you create effective PPC campaigns?"
        title4="Can PPC advertising work for any business?"
        paragraph="PPC advertising is a form of online advertising where advertisers pay each time a user clicks on their ads. These ads are typically displayed in search engine results pages (SERPs) and other online platforms, such as social media and display networks."
        paragraph1="PPC advertising works by creating targeted ads that are displayed to users who are searching for relevant keywords or who fit specific demographic criteria. Advertisers bid on the keywords and placements they want to target, and the highest bidder's ads are displayed to the user."
        paragraph2="PPC advertising offers several benefits, including targeted reach, immediate results, and cost-effectiveness. With PPC, you can reach users who are actively searching for your products or services, and you only pay for clicks, so you can control your advertising spend."
        paragraph3="To create effective PPC campaigns, you need to conduct keyword research, write compelling ad copy, and create targeted landing pages. You also need to continually monitor and optimize your campaigns to ensure they are performing well and delivering a positive ROI."
        paragraph4="PPC advertising can work for almost any business, but it's important to have a clear understanding of your target audience, goals, and budget before launching a campaign. With the right strategy and execution, PPC can be an effective way to drive traffic and generate leads for your business."
      />
      <Footer />
    </>
  );
};

export default PayPerClickMarkecting;
